<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="pt1"> </p>
<p class="pn"><span class="epub-b">Part One</span></p>
<p class="pn-dl"><span class="epub-b">MAJOR ANDRE, UPSTATE NEW YORK,</span></p>
<p class="pn-dl"><span class="epub-b">SEPTEMBER 30–OCTOBER 1, 1780</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?33ae8a79